// extracted by mini-css-extract-plugin
export default {"container":"OQ-z","modal":"PQ-z","dimensions":"QQ-z","brandName":"RQ-z","productName":"SQ-z","recipientEmail":"TQ-z","recommendedFit":"UQ-z","hiddenField":"VQ-z"};